import { render, staticRenderFns } from "./StatusLegends.vue?vue&type=template&id=2adfd69b&scoped=true"
import script from "./StatusLegends.vue?vue&type=script&lang=js"
export * from "./StatusLegends.vue?vue&type=script&lang=js"
import style0 from "./StatusLegends.vue?vue&type=style&index=0&id=2adfd69b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adfd69b",
  null
  
)

export default component.exports